import React, { useState } from 'react';
import { Button, Form, Modal } from "react-bootstrap";
import DatePicker from 'react-datepicker';

const PayemnetsEditModal = ({ show, handleClose }) => {
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Edit Payment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Driver Name:</Form.Label>
                            <Form.Control as="select">
                                <option>Driver A</option>
                                <option>Driver B</option>
                                <option>Driver C</option>
                                <option>Driver D</option>
                                <option>Driver E</option>
                            </Form.Control>
                        </Form.Group>

                        {/* Payment Date */}
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Date:</Form.Label>
                            <Form.Control type="date" />
                        </Form.Group>

                        {/* Payment Method */}
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Method:</Form.Label>
                            <Form.Control type="text" placeholder="Enter payment method" />
                        </Form.Group>

                        {/* Payment Detail */}
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Detail:</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Enter payment details" />
                        </Form.Group>

                        {/* Payment Amount */}
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Amount ($):</Form.Label>
                            <Form.Control type="number" placeholder="Enter payment amount" />
                        </Form.Group>

                        <Button variant="primary" onClick={handleClose}>
                            Save
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default PayemnetsEditModal;